import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';

import RecentActivities from './RecentActivities';
import UsageMetrics from './UsageMetrics';
import ProjectsOverview from './ProjectsOverview';
import EndpointsOverview from './EndpointsOverview';
import APIUsageChart from './APIUsageChart';
import QuickActions from './QuickActions';

const BusinessDashboard = () => {
    document.title = "Dashboard | Integr - Document Processing Platform";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Dashboard" pageTitle="Overview" />

                    {/* Top Row - Projects | Endpoints | Production API Calls */}
                    <Row className="align-items-stretch">
                        <Col xl={3} md={6}>
                            <ProjectsOverview />
                        </Col>
                        <Col xl={3} md={6}>
                            <EndpointsOverview />
                        </Col>
                        <Col xl={6} md={12}>
                            <UsageMetrics />
                        </Col>
                    </Row>

                    {/* Middle Row - API Usage Chart (production) + Quick Actions */}
                    <Row className="mt-4">
                        <Col xl={8}>
                            <APIUsageChart />
                        </Col>
                        <Col xl={4}>
                            <QuickActions />
                        </Col>
                    </Row>

                    {/* Bottom Row - Recent Activities */}
                    <Row className="mt-4">
                        <Col xl={12}>
                            <RecentActivities />
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default BusinessDashboard;
